// File: packages/components/src/agent/TierPresetChips.tsx (Refactored)

import React from 'react';
import { RadioGroup } from '@dopomogai/ui';
import { useCalculator } from '@dopomogai/agent-kit';

/**
 * A visually appealing way to apply a full feature set quickly using presets.
 * It is now wired to the `useCalculator` hook.
 */
export function TierPresetChips() {
  const { spec, state, actions } = useCalculator();

  // Do not render the component if no presets are defined in the spec.
  if (!spec.presets || spec.presets.length === 0) {
    return null;
  }

  // Map the presets from the spec to the format required by the RadioGroup component.
  const options = spec.presets.map((p) => ({
    value: p.id,
    label: p.label,
    description: p.desc, // The UI component can use this for tooltips
  }));

  return (
    <div className="space-y-2">
      <h3 className="text-lg font-bold text-slate-900">
        Start with a Preset
      </h3>
      <RadioGroup
        label="Select a starting preset" // Accessibility label
        labelClassName="sr-only" // Hide the label visually
        options={options}
        // The selected state of the radio group is now driven by `calculator.state.presetId`.
        value={state.presetId}
        // `onChange` now calls the `setPreset` action from the calculator context.
        onChange={(newPresetId) => actions.setPreset(newPresetId as string)}
      />
      <p className="text-xs text-slate-600">
        Selecting a preset is a starting point. You can still customize features individually below.
      </p>
    </div>
  );
}